export default __webpack_public_path__ + "static/media/desktop_step1_bg.508a83d6.png";